(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("VueDemi"));
	else if(typeof define === 'function' && define.amd)
		define(["VueDemi"], factory);
	else if(typeof exports === 'object')
		exports["/fego/component/marquee-img/render"] = factory(require("VueDemi"));
	else
		root["/fego/component/marquee-img/render"] = factory(root["VueDemi"]);
})(self, (__WEBPACK_EXTERNAL_MODULE__9906__) => {
return 